"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import get from "../data/get";
import ReactUtils from "../../react_utils";
import generalFormatter from "../../formatters/general";
import DropSelector from "./drop_selector";
import TmsDeletedWarningIcon from "../load_tms_deleted_warning";
import StopAddress, { citiesAreUnique, streetAndCity } from "./stop_address";
var bem = ReactUtils.makeBem("document-browser");
function delivery(props, cityOnly, tmsDelivery, i) {
  var entry = {
    tms_delivery_id: tmsDelivery.id,
    document_id: props.document.id
  };
  var deliveryDocuments = props.deliveryDocumentSelections;
  var tmsShipment = get.tmsShipment(tmsDelivery);
  var tmsStop = get.tmsStop(tmsDelivery);
  let customerNameText;
  if (!_.isEmpty(tmsShipment.customer)) {
    customerNameText = " for " + tmsShipment.customer.name;
  }
  const isChecked = _.some(deliveryDocuments, entry);
  const isDisabled = !isChecked && _.some(deliveryDocuments, {
    tms_delivery_id: tmsDelivery.id
  });
  const onChange = () => {
    props.toggleDeliveryDocument(entry);
  };
  const weight = generalFormatter.weight(tmsShipment.weight);
  const cssClasses = bem({
    "__assign-documents-selector-item-label": true,
    "__assign-documents-selector-item-label--disabled": isDisabled
  });
  let inlineAddress = null;
  let stackedAddress = null;
  if (!props.showStopAddresses) {
    inlineAddress = streetAndCity(tmsStop);
  } else if (cityOnly) {
    inlineAddress = /* @__PURE__ */ jsx(StopAddress, { stop: tmsStop, cityOnly: true });
  } else {
    stackedAddress = /* @__PURE__ */ jsx(StopAddress, { stop: tmsStop, cityOnly: false });
  }
  let tmsDeletedIcon;
  if (tmsStop.tms_deleted) {
    tmsDeletedIcon = /* @__PURE__ */ jsx(TmsDeletedWarningIcon, {});
  }
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("label", { className: cssClasses, children: [
    i + 1 + ")",
    "\xA0",
    /* @__PURE__ */ jsx(
      "input",
      {
        className: bem("__assign-documents-selector-checkbox"),
        checked: isChecked,
        onChange,
        type: "checkbox"
      }
    ),
    tmsShipment.shipment_id,
    " ",
    customerNameText,
    " ",
    inlineAddress && "@ ",
    inlineAddress,
    " ",
    weight,
    tmsDeletedIcon,
    stackedAddress
  ] }) }, "delivery-" + i);
}
export default function PodDeliverySelector(props) {
  const cityOnly = citiesAreUnique(props.tmsDeliveries.map(get.tmsStop));
  return /* @__PURE__ */ jsx(
    DropSelector,
    {
      tmsObjects: props.tmsDeliveries,
      tmsObjectDetailsFunction: (tmsDelivery, i) => delivery(props, cityOnly, tmsDelivery, i),
      label: "Assign POD to drop",
      grid: props.showStopAddresses && !cityOnly
    }
  );
}
